import URL from "../api_url";

export const BANNER_API = `${URL}/banner-upload`;
